export const VERSION = '2.39.2';
